import React from 'react';
import styled from 'styled-components';
import useStore from '~/store';
import { taxColumnsLabel, paymentColumnsLabel } from '~/../config.json';
import ReactSelect from '~/components/ReactSelect';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 48%;
  max-width: 250px;
`;

const setColumnsSelector = (s) => s.setColumns;

const options = [
  { value: 'taxColumns', label: taxColumnsLabel },
  { value: 'paymentColumns', label: paymentColumnsLabel },
];

export default function ColumnSwitch({ side }) {
  const value = useStore((s) => s[`${side}ColumnsId`]);
  const rsValue = options.find((opt) => opt.value === value);
  const setColumns = useStore(setColumnsSelector);

  const handleColumnSwitch = (option) => {
    setColumns(option.value, side);
  };

  return (
    <Wrapper>
      <ReactSelect options={options} value={rsValue} onChange={handleColumnSwitch} />
    </Wrapper>
  );
}
